module.exports = __webpack_public_path__ + "static/img/book_1.fd8cb65.png";


//////////////////
// WEBPACK FOOTER
// ./static/wap_images/book_1.png
// module id = GVVr
// module chunks = 1